import backendV2Service from './backend-v2.service';

export interface AdminActionLog {
  id: number;
  tableName: string;
  rowPk: string;
  operation: 'INSERT' | 'UPDATE' | 'DELETE';
  columnName: string | null;
  oldValue: string | null;
  newValue: string | null;
  actor: string | null;
  actorSource: 'content-manager' | 'backend-v2' | 'backend-main' | 'retool' | 'unknown';
  createdAt: string;
}

export interface AdminActionLogFilters {
  tableName?: string;
  rowPk?: string;
  actor?: string;
  from?: string;
  to?: string;
}

export interface AdminActionLogResult {
  data: AdminActionLog[];
  totalPages: number;
  total: number;
}

export default {
  findAll: (page: number, filters: AdminActionLogFilters): Promise<AdminActionLogResult> => backendV2Service.get<AdminActionLogResult>('/admin-action-logs', {
    params: { page, ...filters },
  })
    .then(({ data }) => data),
};
